/**
 * Higienização da busca de intenção (max 280 chars).
 * Mitiga injeção de prompt e lixo de controle sem destruir acentos/PT-BR.
 */

export const QUERY_MAX_LEN = 280;

const INJECTION_PATTERNS = [
  /ignore\s+(all\s+)?(previous|prior|above)\s+instructions?/gi,
  /system\s*:\s*/gi,
  /<\s*\/?\s*(system|assistant|user)\s*>/gi,
  /\b(do\s+not\s+follow|disregard)\b.{0,40}\b(instructions?|rules?)\b/gi,
];

/**
 * @param {unknown} raw
 * @returns {{ ok: true, text: string, normalized: string } | { ok: false, error: string }}
 */
export function sanitizeQuery(raw) {
  if (typeof raw !== 'string') {
    return { ok: false, error: 'Consulta inválida' };
  }

  let text = raw
    .normalize('NFKC')
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  if (!text) {
    return { ok: false, error: 'Digite o que você procura' };
  }

  if (text.length > QUERY_MAX_LEN) {
    text = text.slice(0, QUERY_MAX_LEN).trim();
  }

  for (const pattern of INJECTION_PATTERNS) {
    text = text.replace(pattern, ' ');
  }
  text = text.replace(/\s+/g, ' ').trim();

  if (!text) {
    return { ok: false, error: 'Consulta rejeitada após higienização' };
  }

  const normalized = text
    .toLocaleLowerCase('pt-BR')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^\p{L}\p{N}\s]/gu, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, QUERY_MAX_LEN);

  if (!normalized) {
    return { ok: false, error: 'Consulta sem conteúdo utilizável' };
  }

  return { ok: true, text, normalized };
}
